import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/logo-natapp-testsystem.svg'


const _withScopeId = n => (_pushScopeId("data-v-56abcbb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container container--large" }
const _hoisted_2 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Natapp logo"
}, null, -1))
const _hoisted_4 = { class: "search-wrapper form-inline flex-grow-1 mx-5" }
const _hoisted_5 = { class: "w-100 d-none d-lg-flex" }
const _hoisted_6 = {
  key: 0,
  class: "search-overlay bg-white d-block d-lg-none"
}
const _hoisted_7 = { class: "nav-items d-flex" }
const _hoisted_8 = { class: "icons d-flex d-lg-none" }
const _hoisted_9 = {
  key: 0,
  id: "dropdown-profile",
  class: "dropdown b-dropdown btn-group"
}
const _hoisted_10 = ["data-bs-toggle"]
const _hoisted_11 = {
  key: 1,
  class: "mb-0 ps-0 d-sm-block"
}
const _hoisted_12 = { class: "list-unstyled" }
const _hoisted_13 = {
  id: "dropdown-profile",
  class: "dropdown b-dropdown btn-group"
}
const _hoisted_14 = {
  key: 0,
  class: "btn btn-sm btn-black btn-icon fw-bold text-white rounded-circle p-1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_15 = { class: "dropdown-menu dropdown-menu-end mt-1 rounded-1 p-1 border" }
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = { class: "fw-medium" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "ms-n1 me-n1 separator-h opacity-100" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flycon flycon-top flycon-24 flycon-logout me-1 text-color--low-emphasis" }, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Abmelden ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_SearchInputMobile = _resolveComponent("SearchInputMobile")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["nav shadow navbar navbar-expand-lg navbar-light bg-white fixed-top py-2", _ctx.toggleOverlay == true ? 'nav--high-index' : '']),
    id: "nav-bar"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "py-1 navbar-brand",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_SearchInput)
          ]),
          _createVNode(_Transition, { name: "overlay" }, {
            default: _withCtx(() => [
              (_ctx.toggleOverlay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_SearchInputMobile, {
                      toggleOverlay: _ctx.toggleOverlay,
                      onToggleEvent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleOverlay = $event))
                    }, null, 8, ["toggleOverlay"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            "aria-hidden": "true",
            class: "btn btn-link me-1 flycon flycon-top flycon-24 flycon-search text-dark lh-0 rounded-circle p-1 border-0",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleOverlay = !_ctx.toggleOverlay))
          }, " ­ "),
          (!_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("button", {
                  "aria-hidden": "true",
                  class: "btn btn-link flycon flycon-top flycon-24 flycon-profile text-dark lh-0 rounded-circle p-1 border-0",
                  "data-bs-toggle": _ctx.isAuthenticated ? 'dropdown' : '',
                  "aria-expanded": "false",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (!_ctx.isAuthenticated ? _ctx.login() : false))
                }, " ­ ", 8, _hoisted_10)
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.login())),
              class: "btn btn-sm btn-black rounded-pill fw-bold text-white d-none d-lg-block"
            }, " Log me in "))
          : _createCommentVNode("", true),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
              _createElementVNode("li", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.getInitials().firstName)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_14, _toDisplayString(_ctx.getInitials().firstName) + _toDisplayString(_ctx.getInitials().lastName), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_15, [
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "dropdown-item py-1 d-flex flex-column dropdown-item--info",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.navigateToKeycloakProfile && _ctx.navigateToKeycloakProfile(...args)))
                      }, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.userProfile?.firstName) + " " + _toDisplayString(_ctx.userProfile?.lastName), 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.userProfile?.email), 1)
                      ])
                    ]),
                    _hoisted_18,
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "dropdown-item d-flex align-items-center py-1 fw-medium",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.logout()))
                      }, _hoisted_21)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}